(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["butler-lead-survey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    function initialize(root) {
      if (instances.has(root)) return;
      const form = root.querySelector('form');
      const steps = [...root.querySelectorAll('[data-step]')];
      if (!form || !steps.length) return;
      const track = root.querySelector('[data-track]');
      const viewport = root.querySelector('[data-viewport]');
      const back = root.querySelector('[data-back]');
      const next = root.querySelector('[data-next]');
      const submit = root.querySelector('[data-submit]');
      const error = root.querySelector('[data-choice-error]');
      const progress = root.querySelector('[data-progress]');
      const progressFill = root.querySelector('[data-progress-fill]');
      const stepLabel = root.querySelector('[data-step-label]');
      const stepTemplate = root.querySelector('[data-step-template]').textContent;
      let current = 0;
      function measure() {
        viewport.style.height = `${steps[current].getBoundingClientRect().height}px`;
      }
      function show(index, focus = true) {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, i) => {
          step.inert = i !== current;
          step.setAttribute('aria-hidden', String(i !== current));
        });
        track.style.transform = `translateX(-${current * 100}%)`;
        progress.setAttribute('aria-valuenow', String(current + 1));
        progressFill.style.width = `${(current + 1) / steps.length * 100}%`;
        stepLabel.textContent = stepTemplate.replace('__CURRENT__', String(current + 1));
        back.hidden = current === 0;
        next.hidden = current === steps.length - 1;
        submit.hidden = current !== steps.length - 1;
        error.hidden = true;
        measure();
        if (focus) steps[current].querySelector('legend').focus({ preventScroll: true });
      }
      function validateStep(index) {
        const step = steps[index];
        const radios = [...step.querySelectorAll('input[type="radio"]')];
        if (radios.length && !radios.some(input => input.checked)) {
          show(index);
          error.hidden = false;
          radios[0].focus({ preventScroll: true });
          return false;
        }
        const invalid = [...step.querySelectorAll('input')].find(input => !input.checkValidity());
        if (invalid) {
          show(index);
          invalid.reportValidity();
          return false;
        }
        return true;
      }
      function updateSummary() {
        const answers = steps.filter(step => step.dataset.question).map(step => {
          const selected = step.querySelector('input:checked');
          return `${step.dataset.question}: ${selected ? selected.value : ''}`;
        });
        const details = [...steps.at(-1).querySelectorAll('input')].map(input => `${input.previousSibling?.textContent.trim() || input.name}: ${input.value}`);
        root.querySelector('[data-answer-summary]').value = [...answers, '', ...details].join('\n');
      }
      root.classList.add('is-ready');
      form.noValidate = true;
      root.querySelectorAll('[data-wizard-only]').forEach(element => { element.hidden = false; });
      back.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => { if (validateStep(current)) show(current + 1); });
      form.addEventListener('change', () => { error.hidden = true; updateSummary(); });
      form.addEventListener('submit', event => {
        if (current < steps.length - 1) {
          event.preventDefault();
          if (validateStep(current)) show(current + 1);
          return;
        }
        for (let index = 0; index < steps.length; index++) {
          if (!validateStep(index)) { event.preventDefault(); return; }
        }
        updateSummary();
      });
      const observer = new ResizeObserver(measure);
      steps.forEach(step => observer.observe(step));
      const selectBlock = event => {
        if (!root.contains(event.target)) return;
        const index = steps.findIndex(step => step === event.target || step.contains(event.target));
        if (index >= 0) show(index, false);
      };
      root.addEventListener('shopify:block:select', selectBlock);
      instances.set(root, { observer });
      show(root.querySelector('[data-server-errors]') ? steps.length - 1 : 0, false);
    }
    function boot(scope = document) {
      if (scope.matches?.('[data-dbs-survey]')) initialize(scope);
      scope.querySelectorAll('[data-dbs-survey]').forEach(initialize);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', event => boot(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll('[data-dbs-survey]').forEach(root => {
        instances.get(root)?.observer.disconnect();
        instances.delete(root);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
